/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { ListCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel, useLabels } from '@/wpt-lib/pdf/useData';
import { label } from '@/wpt-lib/utils/label';
import { isNullish } from '@/wpt-lib/utils/isNullish';

const NewResearch = ({
    newProjectName,
    newResearchProjectLeadResearcher,
    targetFundingOrg,
    targetIncomeCategory = {},
    targetResearchIncomeThisYear,
    newProjectDetails,
    newResearchProjectDescription,
    newProjectInternalExternalSeedFunded,
}: Partial<{
    newProjectName: string;
    newResearchProjectLeadResearcher: string;
    targetFundingOrg: string;
    targetIncomeCategory: { [cat: string]: boolean };
    targetResearchIncomeThisYear: string;
    newProjectDetails: string;
    newResearchProjectDescription: string;
    newProjectInternalExternalSeedFunded: string;
}>) => {
    const cats = useLabels('targetIncomeCategory');

    return (
        <>
            <Row>
                <ValueCell label="Project Name" value={newProjectName} />
            </Row>
            {(!isNullish(newProjectDetails) || !isNullish(newResearchProjectDescription)) && (
                <Row>
                    <ValueCell label={'Project details'} value={newProjectDetails ?? newResearchProjectDescription} />
                </Row>
            )}
            <Row>
                <ValueCell label="Targeted research income for this year" value={targetResearchIncomeThisYear} />
                <ValueCell label="Targeted Funding Organisation" value={targetFundingOrg} />
            </Row>
            {!isNullish(newProjectInternalExternalSeedFunded) && (
                <Row>
                    <ValueCell
                        single
                        label="Project Seed Funded"
                        value={useLabel('newProjectInternalExternalSeedFunded', newProjectInternalExternalSeedFunded)}
                    />
                </Row>
            )}
            <Row>
                <ListCell
                    label="Income Category"
                    values={Object.entries(targetIncomeCategory)
                        .filter(([, y]) => y)
                        .map(([c]) => label(cats, c))}
                />
            </Row>
            <Row>
                <ValueCell
                    single
                    label="I expect to be the lead researcher"
                    value={useLabel('newResearchProjectLeadResearcher', newResearchProjectLeadResearcher ?? '')}
                />
            </Row>
        </>
    );
};

export default NewResearch;
